// ---------------------------------------------------------------------------
// LA RÉSERVE DE POLICES SERVIES PAR CE DOMAINE (Toji, 21/10)
// ---------------------------------------------------------------------------
// Familles libres (OFL ou Apache, prises sur Google Fonts) copiées dans
// public/polices/ — sous-ensembles latin et latin-ext seulement — et décrites
// par public/polices/reserve.css. Ce fichier n'est chargé qu'à la demande (le
// panneau des sous-titres, ou une police de la réserve déjà choisie) : rien de
// plus au premier affichage. Les fichiers sont surveillés par
// public/polices/manifeste.json (essai polices-manifeste.mjs).
//
// Les catégories sont celles du panneau des sous-titres.
// ---------------------------------------------------------------------------

export const CATEGORIES_POLICES = Object.freeze({
  sans: 'Sans empattement',
  serif: 'Avec empattement',
  mono: 'Chasse fixe',
  manuscrite: 'Manuscrite',
  affiche: 'Affiche',
});

const r = (categorie, ...familles) => familles.map((famille) => ({ famille, categorie }));

export const RESERVE_POLICES = Object.freeze([
  ...r('sans', 'Inter', 'Roboto', 'Open Sans', 'Lato', 'Noto Sans', 'Source Sans 3', 'Nunito',
    'Montserrat', 'Poppins', 'Work Sans', 'Fira Sans', 'PT Sans', 'Atkinson Hyperlegible', 'Lexend',
    'IBM Plex Sans', 'Mulish', 'Karla', 'Rubik', 'Cabin', 'Barlow', 'Figtree', 'Manrope'),
  ...r('serif', 'Merriweather', 'Lora', 'Source Serif 4', 'PT Serif', 'Noto Serif', 'EB Garamond',
    'Libre Baskerville', 'Crimson Pro', 'Playfair Display', 'Literata', 'Bitter', 'Roboto Slab', 'Zilla Slab'),
  ...r('mono', 'JetBrains Mono', 'Source Code Pro', 'IBM Plex Mono', 'Roboto Mono', 'Space Mono',
    'Inconsolata', 'Fira Mono'),
  ...r('manuscrite', 'Caveat', 'Patrick Hand', 'Kalam', 'Comic Neue', 'Architects Daughter',
    'Dancing Script', 'Indie Flower'),
  ...r('affiche', 'Oswald', 'Anton', 'Bangers', 'Archivo Black', 'Fjalla One', 'Alfa Slab One', 'Righteous'),
].map(Object.freeze));

const NOMS = new Set(RESERVE_POLICES.map((p) => p.famille.toLowerCase()));
/** Cette famille est-elle servie par la réserve ? */
export const dansLaReserve = (famille) => NOMS.has(String(famille ?? '').toLowerCase());

/** Ajoute reserve.css à la page, une seule fois. Les fichiers, eux, ne partent qu'à l'usage. */
export function chargerReserve() {
  if (typeof document === 'undefined' || document.getElementById('polices-reserve')) return;
  const lien = document.createElement('link');
  lien.id = 'polices-reserve';
  lien.rel = 'stylesheet';
  lien.href = '/polices/reserve.css';
  document.head.appendChild(lien);
}
